import axios from 'axios';

export const productMasterApi = axios.create({
	baseURL: `${process.env.REACT_APP_API_URL}/Master`,
});
export const MaestroApi = axios.create({
	baseURL: `${process.env.REACT_APP_API_URL}/Maestro`,
});

